import { Reducer } from 'redux';
import { IUpdatePasswordActionTypes, IUpdatePasswordState } from './Types';

const initialState: IUpdatePasswordState = {
	isNewPwdValid: false,
	newPwdInvalidMsg: '',
	isUpdateSucceed: false,
	updateIsErrorMsg: '',
	newpwd: '',
	oldpwd: '',
	token: '',
};

const reducer: Reducer<IUpdatePasswordState> = (
	state = initialState,
	action
) => {
	switch (action.type) {
		case IUpdatePasswordActionTypes.NEW_PASSWORD_IS_INVALID: {
			return {
				...state,
				newPwdInvalidMsg: action.payload,
				isNewPwdValid: false,
			};
		}

		case IUpdatePasswordActionTypes.NEW_PASSWORD_IS_VALID: {
			return {
				...state,
				newPwdInvalidMsg: '',
				isNewPwdValid: true,
			};
		}

		case IUpdatePasswordActionTypes.UPDATE_PASSWORD_FAILED: {
			return {
				...state,
				updateIsErrorMsg: action.payload,
				isUpdateSucceed: false,
			};
		}

		case IUpdatePasswordActionTypes.UPDATE_PASSWORD_SUCCEED: {
			return {
				...state,
				updateIsErrorMsg: '',
				isUpdateSucceed: true,
			};
		}

		default: {
			return state;
		}
	}
};

export { reducer as UpdatePasswordReducer };
